/* Domeliss — script unique du thème (chargé en defer sur les gabarits Domeliss).
   Chaque module s'active sur un attribut data-* présent dans le balisage ; aucun ne modifie la structure des pages.
   Réglages (heure limite, code cadeau, produits) : balise <script id="dm-config"> du layout. */
(function () {
  'use strict';

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('dm-config').textContent); } catch (e) {}
  var CUTOFF = CFG.cutoff || 14;
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE = window.matchMedia('(max-width: 900px)');

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  function two(n) { return (n < 10 ? '0' : '') + n; }
  function openDialog(d) {
    if (!d || d.open) return;
    if (typeof d.showModal === 'function') d.showModal(); else d.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDialog(d) {
    if (!d) return;
    if (typeof d.close === 'function') d.close(); else d.removeAttribute('open');
    document.documentElement.style.overflow = '';
  }
  function bindDialog(d) {
    if (!d) return;
    d.addEventListener('close', function () { document.documentElement.style.overflow = ''; });
    d.addEventListener('click', function (e) { if (e.target === d) closeDialog(d); });
    $$('[data-close]', d).forEach(function (b) { b.addEventListener('click', function () { closeDialog(d); }); });
  }

  /* ---------- En-tête : réduit après 40 px, masqué en descendant, réaffiché en remontant ---------- */
  (function header() {
    var hg = document.getElementById('header-group');
    if (!hg) return;
    var last = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      hg.classList.toggle('is-scrolled', y > 40);
      if (y > last && y > 160) hg.classList.add('is-hidden');
      else if (y < last) hg.classList.remove('is-hidden');
      last = y;
    }, { passive: true });
  })();

  /* ---------- Bandeau d'annonces : défilement continu sur mobile, glissable au doigt ---------- */
  (function announce() {
    var bar = $('[data-announce]'), track = bar && $('.dm-announce__track', bar);
    if (!track) return;
    var mq = window.matchMedia('(max-width: 700px)');
    var pos = 0, last = 0, drag = false, horiz = null, sx = 0, sy = 0, sp = 0, lx = 0, lt = 0, vel = 0, resume = 0, running = false;
    function wrap() { var h = track.scrollWidth / 2; if (h > 0) pos = ((pos % h) + h) % h; }
    bar.addEventListener('touchstart', function (e) {
      var p = e.touches[0]; drag = true; horiz = null; sx = lx = p.clientX; sy = p.clientY; sp = pos; lt = performance.now(); vel = 0;
    }, { passive: true });
    bar.addEventListener('touchmove', function (e) {
      if (!drag) return;
      var p = e.touches[0], dx = p.clientX - sx, dy = p.clientY - sy;
      if (horiz === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) horiz = Math.abs(dx) > Math.abs(dy);
      if (!horiz) return;
      var now = performance.now(), d = now - lt;
      if (d > 0) vel = 0.8 * ((lx - p.clientX) / d) + 0.2 * vel;
      lx = p.clientX; lt = now; pos = sp - dx; wrap();
    }, { passive: true });
    function end() { if (!drag) return; drag = false; if (!horiz) vel = 0; resume = performance.now() + 2500; }
    bar.addEventListener('touchend', end, { passive: true });
    bar.addEventListener('touchcancel', end, { passive: true });
    function loop(ts) {
      if (!mq.matches) { running = false; last = 0; track.style.transform = ''; return; }
      var dt = last ? Math.min(ts - last, 50) : 0; last = ts;
      if (!drag || horiz === false) {
        if (Math.abs(vel) > 0.02) { pos += vel * dt; vel *= Math.pow(0.95, dt / 16); }
        else { vel = 0; if (ts >= resume && !REDUCE) pos += dt * 0.0365; }
        wrap();
      }
      track.style.transform = 'translate3d(' + (-pos) + 'px,0,0)';
      requestAnimationFrame(loop);
    }
    function start() { if (mq.matches && !running) { running = true; requestAnimationFrame(loop); } }
    mq.addEventListener('change', start);
    start();
  })();

  /* ---------- Pied de page : colonnes en accordéon sur mobile ---------- */
  (function footer() {
    var toggles = $$('[data-footer-toggle]');
    if (!toggles.length) return;
    function group(b) { return b.closest('[data-footer-group]'); }
    function sync() {
      toggles.forEach(function (b) {
        var g = group(b);
        if (MOBILE.matches) b.setAttribute('aria-expanded', String(!g.classList.contains('is-closed')));
        else b.removeAttribute('aria-expanded');
        b.tabIndex = MOBILE.matches ? 0 : -1;
      });
    }
    toggles.forEach(function (b) {
      b.addEventListener('click', function () {
        if (!MOBILE.matches) return;
        group(b).classList.toggle('is-closed');
        sync();
      });
    });
    MOBILE.addEventListener('change', sync);
    sync();
  })();

  /* ---------- Délai d'expédition et de livraison (jours ouvrables, fériés français) ---------- */
  var DAY = 86400000, holCache = {};
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
      g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4,
      l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return Date.UTC(y, mo - 1, da);
  }
  function holidays(y) {
    if (holCache[y]) return holCache[y];
    var e = easter(y), s = {};
    ['0-1', '4-1', '4-8', '6-14', '7-15', '10-1', '10-11', '11-25'].forEach(function (x) { var p = x.split('-'); s[Date.UTC(y, +p[0], +p[1])] = 1; });
    [e + DAY, e + 39 * DAY, e + 50 * DAY].forEach(function (t) { s[t] = 1; });
    return (holCache[y] = s);
  }
  function isBiz(t) {
    var d = new Date(t);
    if (d.getUTCDay() === 0) return false;
    return !holidays(d.getUTCFullYear())[Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())];
  }
  function addBiz(t, n) { while (n > 0) { t += DAY; if (isBiz(t)) n--; } return t; }
  function parisNow() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
  }
  function fmt(t, o) { return new Date(t).toLocaleDateString('fr-FR', Object.assign({ timeZone: 'UTC' }, o)); }
  function shipping() {
    var now = parisNow(), day = now - now % DAY, ship = (isBiz(day) && now < day + CUTOFF * 3600000) ? day : addBiz(day, 1);
    return { now: now, day: day, ship: ship, a: addBiz(ship, 2), b: addBiz(ship, 3) };
  }
  (function eta() {
    var boxes = $$('[data-eta]');
    if (!boxes.length) return;
    function tick() {
      var s = shipping();
      var when = s.ship === s.day ? 'aujourd’hui' : (s.ship === s.day + DAY ? 'demain' : null);
      boxes.forEach(function (box) {
        var head = $('[data-eta-head]', box), date = $('[data-eta-date]', box);
        if (box.getAttribute('data-eta') === 'cart') {
          head.innerHTML = (s.ship === s.day ? 'Commandé avant ' + CUTOFF + ' h, ' : 'Commandé maintenant, ') +
            '<b>expédié ' + (when || fmt(s.ship, { weekday: 'long' })) + '</b>. Livraison estimée <b>' +
            fmt(s.a, { weekday: 'short', day: 'numeric' }) + ' – ' + fmt(s.b, { weekday: 'short', day: 'numeric', month: 'short' }) + '</b>';
          return;
        }
        var left = Math.max(0, Math.floor((s.ship + CUTOFF * 3600000 - s.now) / 1000));
        var w = when || fmt(s.ship, { weekday: 'long', day: 'numeric', month: 'long' });
        head.innerHTML = left < 86400
          ? 'Commandez dans <span class="dm-clock"><i>' + two(Math.floor(left / 3600)) + ' h</i><i>' + two(Math.floor(left % 3600 / 60)) + ' min</i><i>' + two(left % 60) + ' s</i></span> : <b>expédié ' + w + '</b>.'
          : 'Commandez avant <b>' + fmt(s.ship, { weekday: 'long' }) + ' ' + CUTOFF + ' h</b> : expédié ' + w + '.';
        date.textContent = 'Livraison estimée entre le ' + fmt(s.a, { weekday: 'short', day: 'numeric' }) + ' et le ' + fmt(s.b, { weekday: 'short', day: 'numeric', month: 'long' }) + '.';
      });
    }
    tick();
    if ($$('[data-eta]:not([data-eta="cart"])').length) setInterval(tick, 1000);
  })();

  /* ---------- Protège-oreiller offert dès 4 protège-matelas : applique ou retire le code de réduction ---------- */
  function syncGift() {
    var C = String(CFG.giftCode || '').toUpperCase(), up = function (x) { return String(x).toUpperCase(); };
    if (!C || !window.fetch) return Promise.resolve(false);
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var n = 0, g = 0;
      c.items.forEach(function (i) { if (i.handle === CFG.mattress) n += i.quantity; if (i.handle === CFG.pillow) g += i.quantity; });
      var codes = (c.discount_codes || []).map(function (d) { return d.code; });
      var has = codes.some(function (x) { return up(x) === C; }), want = n >= 4 && g > 0;
      if (has === want) return false;
      var list = codes.filter(function (x) { return up(x) !== C; });
      if (want) list.push(C);
      return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: list.join(',') }) })
        .then(function (r) { return r.json(); })
        .then(function (c2) { return (c2.discount_codes || []).some(function (d) { return up(d.code) === C; }) === want; });
    }).catch(function () { return false; });
  }

  /* ---------- Carte d'achat par lots (protège-matelas) ---------- */
  (function buybox() {
    var form = $('[data-lots-form]');
    if (!form) return;
    var root = form.closest('[data-buy]') || document;
    var rates = {}, gift = +form.getAttribute('data-gift') || 0;
    $$('[data-pack-input]', form).forEach(function (r) { rates[r.value] = +r.getAttribute('data-rate') || 0; });
    function pack() { var r = $('[data-pack-input]:checked', form); return r ? +r.value : 1; }
    function lines() {
      var n = pack(), out = [];
      $$('[data-line]', form).forEach(function (l) {
        var i = +l.getAttribute('data-line'), sel = $('select', l);
        l.hidden = i > n;
        if (i <= n) { var o = sel.selectedOptions[0]; out.push({ id: +o.value, cents: +o.getAttribute('data-cents') }); }
      });
      return out;
    }
    function render() {
      var ls = lines(), n = ls.length, sum = 0;
      ls.forEach(function (x) { sum += x.cents; });
      var rate = rates[Math.min(n, 4)] || 0, total = Math.round(sum * (100 - rate) / 100);
      $$('[data-unit]', form).forEach(function (e) {
        var r = +e.getAttribute('data-unit');
        e.textContent = money(Math.round(ls[0].cents * (100 - r) / 100)) + (r ? ' / pièce' : '');
      });
      $$('[data-total]').forEach(function (e) { e.textContent = money(total); });
      var was = $('[data-was]', root);
      if (was) { was.hidden = !rate; was.textContent = money(sum); }
      var save = $('[data-save]', root);
      if (save) {
        save.textContent = rate ? 'Vous économisez ' + money(sum - total) + ' (-' + rate + ' %)' + (n >= 4 && gift ? ' + protège-oreiller offert' : '') + ' · livraison offerte' : 'TTC, livraison offerte';
        save.classList.toggle('dm-save', !!rate);
      }
      var bonus = $('[data-bonus]', root);
      if (bonus) bonus.hidden = n < 4;
      $$('[data-items]').forEach(function (e) { e.textContent = n + (n > 1 ? ' articles' : ' article'); });
    }
    form.addEventListener('change', render);
    form.addEventListener('submit', function (ev) {
      if (!window.fetch) return;
      ev.preventDefault();
      var agg = {};
      lines().forEach(function (x) { agg[x.id] = (agg[x.id] || 0) + 1; });
      var items = Object.keys(agg).map(function (k) { return { id: +k, quantity: agg[k] }; });
      if (gift && pack() >= 4) items.push({ id: gift, quantity: 1 });
      var btn = $('[type=submit]', form);
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw r; return syncGift(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
    render();

    /* Lots du bandeau d'accueil : sélectionnent le lot et amènent à la carte d'achat */
    $$('[data-hero-pack]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var r = form.querySelector('[data-pack-input][value="' + a.getAttribute('data-hero-pack') + '"]');
        if (!r) return;
        e.preventDefault();
        r.checked = true;
        render();
        var hg = document.getElementById('header-group');
        if (hg) hg.classList.remove('is-hidden');
        $('[data-packs]', form).scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'center' });
      });
    });

    /* Barre d'achat collante (mobile), visible une fois la carte d'achat dépassée */
    var sticky = $('[data-sticky]'), buy = document.getElementById('acheter');
    if (sticky && buy && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var on = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', on);
        sticky.inert = !on;
      }).observe(buy);
    }
  })();

  /* ---------- Quantité (protège-oreiller) ---------- */
  (function quantity() {
    var form = $('[data-qty-form]');
    if (!form) return;
    var input = $('input[name="quantity"]', form), unit = +form.getAttribute('data-unit') || 0, max = +input.max || 20;
    function set(n) {
      n = Math.max(1, Math.min(max, parseInt(n, 10) || 1));
      input.value = n;
      $$('[data-total]', form).forEach(function (e) { e.textContent = money(unit * n); });
      $$('[data-q]', form).forEach(function (b) { b.setAttribute('aria-pressed', String(+b.getAttribute('data-q') === n)); });
    }
    $$('[data-q]', form).forEach(function (b) { b.addEventListener('click', function () { set(b.getAttribute('data-q')); }); });
    $$('[data-qty-step]', form).forEach(function (b) { b.addEventListener('click', function () { set(+input.value + +b.getAttribute('data-qty-step')); }); });
    input.addEventListener('input', function () { if (input.value !== '') set(input.value); });
    input.addEventListener('blur', function () { set(input.value); });
    set(input.value);
  })();

  /* ---------- Galerie produit ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('[data-main]', g), img = $('img', main);
    if (!img) return;
    var thumbs = $$('.dm-gallery__thumb', g), strip = $('.dm-gallery__thumbs', g);
    var items = thumbs.length
      ? thumbs.map(function (t) { return { src: t.getAttribute('data-src'), alt: t.getAttribute('data-alt') || '' }; })
      : [{ src: img.currentSrc || img.src, alt: img.alt }];
    var n = items.length, cur = 0, count = $('[data-count]', main);
    function reveal(i) {
      if (!strip || !thumbs[i]) return;
      var t = thumbs[i], l = t.offsetLeft - strip.offsetLeft, r = l + t.offsetWidth;
      if (l < strip.scrollLeft) strip.scrollLeft = l;
      else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = r - strip.clientWidth;
    }
    function show(i) {
      cur = (i + n) % n;
      img.removeAttribute('srcset');
      img.src = items[cur].src;
      img.alt = items[cur].alt;
      thumbs.forEach(function (t, k) { if (k === cur) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (count) count.textContent = (cur + 1) + ' / ' + n;
      reveal(cur);
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); restart(); }); });
    $$('[data-step]', main).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); show(cur + +b.getAttribute('data-step')); restart(); });
    });
    var sx = null, sy = 0;
    main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; hold(); }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      sx = null;
      if (Math.abs(dx) >= 40 && Math.abs(dx) >= Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });

    /* Défilement automatique toutes les 4 s, avec barre de progression et bouton pause */
    var DUR = 4000, progress = $('.dm-gallery__progress', g), bar = progress && progress.firstElementChild,
      pauseBtn = $('[data-pause]', main), timer = null, hover = false, inView = true, lbOpen = false, stopped = false, touchTimer = null;
    var auto = n > 1 && !REDUCE && bar;
    function paused() { return stopped || hover || !inView || document.hidden || lbOpen; }
    function runBar() { bar.style.transition = 'none'; bar.style.width = '0'; void bar.offsetWidth; bar.style.transition = 'width ' + DUR + 'ms linear'; bar.style.width = '100%'; }
    function stopBar() { var w = getComputedStyle(bar).width; bar.style.transition = 'none'; bar.style.width = w; }
    function restart() {
      if (!auto) return;
      clearTimeout(timer);
      if (paused()) { stopBar(); return; }
      runBar();
      timer = setTimeout(function () { show(cur + 1); restart(); }, DUR);
    }
    function hold() {
      if (!auto) return;
      hover = true; restart();
      clearTimeout(touchTimer);
      touchTimer = setTimeout(function () { hover = false; restart(); }, 6000);
    }
    if (auto) {
      progress.hidden = false;
      pauseBtn.hidden = false;
      pauseBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        stopped = !stopped;
        pauseBtn.setAttribute('aria-pressed', String(stopped));
        pauseBtn.setAttribute('aria-label', stopped ? 'Reprendre le défilement des images' : 'Mettre en pause le défilement des images');
        pauseBtn.innerHTML = '<svg class="dm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (stopped ? '<path d="M8 5.5v13l10-6.5z"/>' : '<path d="M9 6v12M15 6v12"/>') + '</svg>';
        restart();
      });
      g.addEventListener('mouseenter', function () { hover = true; restart(); });
      g.addEventListener('mouseleave', function () { hover = false; restart(); });
      g.addEventListener('focusin', function () { hover = true; restart(); });
      g.addEventListener('focusout', function () { hover = false; restart(); });
      document.addEventListener('visibilitychange', restart);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; restart(); }).observe(g);
      restart();
    }

    /* Visionneuse plein écran (un seul niveau de zoom) */
    var lb = $('[data-lightbox]', g), limg = $('[data-lightbox-image]', lb), lcount = $('[data-lightbox-count]', lb), li = 0;
    function big(u) { return (u || '').replace(/([?&])width=\d+/, '$1width=2000'); }
    function lbShow(i) { li = (i + n) % n; limg.src = big(items[li].src); limg.alt = items[li].alt; if (lcount) lcount.textContent = (li + 1) + ' / ' + n; }
    function lbOpen_() { lbShow(cur); openDialog(lb); lbOpen = true; restart(); }
    bindDialog(lb);
    lb.addEventListener('close', function () { lbOpen = false; restart(); });
    $('[data-zoom]', main).addEventListener('click', function (e) { e.stopPropagation(); lbOpen_(); });
    main.addEventListener('click', function (e) { if (!e.target.closest('button')) lbOpen_(); });
    $$('[data-lightbox-step]', lb).forEach(function (b) { b.addEventListener('click', function () { lbShow(li + +b.getAttribute('data-lightbox-step')); }); });
    lb.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') lbShow(li - 1); else if (e.key === 'ArrowRight') lbShow(li + 1); });
    /* Balayage au doigt (mobile) : image suivante ou précédente ; le zoom à deux doigts du navigateur reste libre */
    var lsx = null, lsy = 0, swiped = false;
    lb.addEventListener('touchstart', function (e) {
      swiped = false;
      if (e.touches.length > 1 || (window.visualViewport && window.visualViewport.scale > 1.01)) { lsx = null; return; }
      lsx = e.touches[0].clientX; lsy = e.touches[0].clientY;
    }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (lsx === null || n < 2 || e.touches.length) { lsx = null; return; }
      var dx = e.changedTouches[0].clientX - lsx, dy = e.changedTouches[0].clientY - lsy;
      lsx = null;
      if (Math.abs(dx) >= 40 && Math.abs(dx) >= Math.abs(dy)) { swiped = true; lbShow(li + (dx < 0 ? 1 : -1)); }
    }, { passive: true });
    $('[data-stage]', lb).addEventListener('click', function (e) { if (swiped) { swiped = false; return; } if (e.target !== limg) closeDialog(lb); });
  });

  /* ---------- Avis clients : carrousel en boucle, avis complet, widget Judge.me ---------- */
  (function reviews() {
    var sec = $('[data-reviews]');
    var dAll = $('[data-all-dialog]'), dOne = $('[data-review-dialog]');
    bindDialog(dAll); bindDialog(dOne);
    function showAll(e) { if (e) e.preventDefault(); if (dOne && dOne.open) closeDialog(dOne); openDialog(dAll); }
    $$('[data-reviews-all]').forEach(function (b) { b.addEventListener('click', showAll); });
    if (!sec) return;
    var track = $('[data-track]', sec), vp = $('[data-viewport]', sec), dotsEl = $('[data-dots]', sec), pauseBtn = $('[data-pause]', sec);
    var cards = $$('.dm-review', track), n = cards.length;
    if (!n) return;
    cards.forEach(function (c, i) { c.setAttribute('data-i', i); });
    function clone(c) { var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.inert = true; return k; }
    var before = document.createDocumentFragment(), after = document.createDocumentFragment();
    cards.forEach(function (c) { before.appendChild(clone(c)); after.appendChild(clone(c)); });
    track.insertBefore(before, track.firstChild);
    track.appendChild(after);
    var all = $$('.dm-review', track), idx = n, busy = false, cur = 0;
    function pv() { return parseInt(getComputedStyle(sec).getPropertyValue('--pv'), 10) || 1; }
    function stepW() { return all[1].getBoundingClientRect().left - all[0].getBoundingClientRect().left; }
    function pages() { return Math.ceil(n / pv()); }
    function renderDots() {
      var p = pages(), a = Math.floor((((idx - n) % n) + n) % n / pv());
      if (dotsEl.children.length !== p) {
        dotsEl.innerHTML = '';
        for (var i = 0; i < p; i++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'dm-dot'; b.setAttribute('aria-label', 'Page ' + (i + 1) + ' sur ' + p); b.innerHTML = '<span></span>';
          (function (k) { b.addEventListener('click', function () { go(n + k * pv()); restart(); }); })(i);
          dotsEl.appendChild(b);
        }
      }
      Array.prototype.forEach.call(dotsEl.children, function (b, i) { b.setAttribute('aria-current', String(i === a)); });
    }
    function place(anim) {
      track.classList.toggle('no-anim', !anim);
      track.style.transform = 'translate3d(' + (-idx * stepW()) + 'px,0,0)';
      if (!anim) void track.offsetWidth;
      renderDots();
    }
    function go(to) { if (busy) return; busy = true; idx = to; place(true); if (REDUCE) settle(); }
    function settle() { busy = false; if (idx >= 2 * n) { idx -= n; place(false); } else if (idx < n) { idx += n; place(false); } }
    track.addEventListener('transitionend', function (e) { if (e.target === track) settle(); });
    $$('[data-step]', sec).forEach(function (b) { b.addEventListener('click', function () { go(idx + +b.getAttribute('data-step') * pv()); restart(); }); });

    var sx = null, sy = 0, dx = 0, moved = false;
    vp.addEventListener('pointerdown', function (e) { if (busy) return; sx = e.clientX; sy = e.clientY; dx = 0; });
    vp.addEventListener('pointermove', function (e) {
      if (sx === null) return;
      dx = e.clientX - sx;
      if (Math.abs(dx) > Math.abs(e.clientY - sy) && Math.abs(dx) > 6) {
        track.classList.add('no-anim');
        track.style.transform = 'translate3d(' + (-idx * stepW() + dx) + 'px,0,0)';
      }
    });
    function endDrag() {
      if (sx === null) return;
      var d = dx; moved = Math.abs(d) > 6; sx = null; dx = 0;
      if (Math.abs(d) > 40) { go(idx + (d < 0 ? 1 : -1) * pv()); restart(); } else place(true);
    }
    vp.addEventListener('pointerup', endDrag);
    vp.addEventListener('pointercancel', endDrag);
    vp.addEventListener('pointerleave', endDrag);
    vp.addEventListener('click', function (e) { if (moved) { moved = false; e.preventDefault(); e.stopPropagation(); } }, true);

    function fill(i) {
      cur = (i + n) % n;
      var c = cards[cur], f = function (k) { return $('[data-' + k + ']', c).textContent; };
      $('[data-one-title]', dOne).textContent = f('title');
      $('[data-one-meta]', dOne).textContent = f('name') + ' · ' + f('date') + ' · ' + f('meta');
      var body = $('[data-one-body]', dOne);
      body.textContent = f('body');
      body.scrollTop = 0;
    }
    function checkMore() {
      all.forEach(function (c) { var b = $('[data-body]', c); $('[data-more]', c).hidden = !(b.scrollHeight > b.clientHeight + 2); });
    }
    all.forEach(function (c) { $('[data-more]', c).addEventListener('click', function () { fill(+c.getAttribute('data-i')); openDialog(dOne); }); });
    $$('[data-one-step]', dOne).forEach(function (b) { b.addEventListener('click', function () { fill(cur + +b.getAttribute('data-one-step')); }); });
    window.addEventListener('resize', function () { idx = n + Math.floor((((idx - n) % n) + n) % n / pv()) * pv(); place(false); checkMore(); });
    place(false); checkMore();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { place(false); checkMore(); });

    /* Défilement automatique toutes les 5 s, avec bouton pause */
    var timer = null, hover = false, touchHold = false, inView = true, stopped = false;
    function tick() {
      if (stopped || hover || touchHold || !inView || document.hidden || (dOne && dOne.open) || (dAll && dAll.open)) return;
      go(idx + pv());
    }
    function restart() { if (REDUCE) return; clearInterval(timer); timer = setInterval(tick, 5000); }
    if (REDUCE) pauseBtn.hidden = true;
    pauseBtn.addEventListener('click', function () {
      stopped = !stopped;
      pauseBtn.setAttribute('aria-pressed', String(stopped));
      pauseBtn.setAttribute('aria-label', stopped ? 'Reprendre le défilement des avis' : 'Mettre en pause le défilement des avis');
      pauseBtn.innerHTML = '<svg class="dm-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (stopped ? '<path d="M8 5.5v13l10-6.5z"/>' : '<path d="M9 6v12M15 6v12"/>') + '</svg>';
    });
    sec.addEventListener('mouseenter', function () { hover = true; });
    sec.addEventListener('mouseleave', function () { hover = false; });
    sec.addEventListener('focusin', function () { hover = true; });
    sec.addEventListener('focusout', function () { hover = false; });
    vp.addEventListener('touchstart', function () { touchHold = true; }, { passive: true });
    vp.addEventListener('touchend', function () { setTimeout(function () { touchHold = false; }, 3000); }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; }).observe(sec);
    restart();
  })();

  /* ---------- Cartes à balayer (mobile) : barre de progression ---------- */
  $$('[data-swipe]').forEach(function (list) {
    var bar = list.nextElementSibling && $('i', list.nextElementSibling);
    if (!bar) return;
    var start = 100 / list.children.length;
    function upd() { var max = list.scrollWidth - list.clientWidth; bar.style.width = (start + (100 - start) * (max > 0 ? list.scrollLeft / max : 0)) + '%'; }
    list.addEventListener('scroll', upd, { passive: true });
    upd();
  });

  /* ---------- Menu déroulant à choix multiples (page Professionnels) : résumé des choix, fermeture au clic extérieur ou Échap ---------- */
  $$('[data-multi]').forEach(function (d) {
    var out = $('[data-multi-value]', d), empty = out.textContent;
    function upd() {
      var v = $$('input:checked', d).map(function (i) { return i.parentNode.textContent.trim(); });
      out.textContent = v.length ? v.join(', ') : empty;
    }
    d.addEventListener('change', upd);
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && d.open) { d.open = false; $('summary', d).focus(); } });
    document.addEventListener('click', function (e) { if (d.open && !d.contains(e.target)) d.open = false; });
    upd();
  });

  /* ---------- Page FAQ : catégorie active dans les pastilles ---------- */
  (function faqPills() {
    var pills = $$('[data-pill]');
    if (!pills.length) return;
    function activate(id) { pills.forEach(function (p) { p.setAttribute('aria-current', String(p.getAttribute('href') === '#' + id)); }); }
    pills.forEach(function (p) {
      p.addEventListener('click', function (e) {
        var id = p.getAttribute('href').slice(1), target = document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        activate(id);
        target.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + id);
      });
    });
  })();

  /* ---------- Panier : quantités et cadeau du lot de 4 ---------- */
  (function cart() {
    var form = $('[data-cart-form]');
    if (!form) return;
    $$('[data-cart-step]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = $('input', b.parentNode);
        i.value = Math.max(0, (parseInt(i.value, 10) || 0) + +b.getAttribute('data-cart-step'));
        form.submit();
      });
    });
    $$('[data-cart-qty]', form).forEach(function (i) { i.addEventListener('change', function () { form.submit(); }); });
    syncGift().then(function (changed) { if (changed) location.reload(); });
  })();

  /* ---------- Animations au défilement : [data-dm-reveal], [data-dm-num], [data-dm-stars] ----------
     Les éléments déjà visibles au chargement ne sont pas animés (pas de clignotement).
     Désactivé si « réduire les animations » ; sans script, tout reste visible. */
  (function motion() {
    if (REDUCE || !('IntersectionObserver' in window)) return;
    var els = $$('[data-dm-reveal],[data-dm-num],[data-dm-stars]');
    if (!els.length) return;
    function countUp(el) {
      var s = $('strong', el), m = s && s.textContent.match(/(\d+),(\d+)/);
      if (!m) return;
      var tpl = s.textContent, end = parseFloat(m[1] + '.' + m[2]), dec = m[2].length, t0 = null;
      function step(t) {
        if (t0 === null) t0 = t;
        var p = Math.min((t - t0) / 1100, 1), v = end * (1 - Math.pow(1 - p, 3));
        s.textContent = tpl.replace(m[0], v.toFixed(dec).replace('.', ','));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        if (e.target.hasAttribute('data-dm-stars')) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    var vh = window.innerHeight;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) el.classList.add(el.hasAttribute('data-dm-stars') ? 'is-static' : 'is-in');
      else io.observe(el);
    });
    document.documentElement.classList.add('is-motion');
  })();
})();
